<div class="spinnerAndTextContainer">
<!--  <mat-icon color="warn">warning</mat-icon>-->
  <div class="textContainer warnColor">
    <ng-content></ng-content>
  </div>
</div>